import{PRODUCT_NOT_AVAILABLE}from"../constants";/**
 * Creates the dispatched PRODUCT_NOT_AVAILABLE action object.
 * @param {string} productId Ids of the products to be set as expired.
 * @param {string|Symbol} reason unavailable reason.
 * @returns {Object} The dispatched action object.
 */var productNotAvailable=function productNotAvailable(productId,reason){return{type:PRODUCT_NOT_AVAILABLE,productId:productId,reason:reason};};export default productNotAvailable;